import { useTranslation } from "react-i18next";

import { Warehouse } from "../../models/warehouse";

export const getAllWarehouseOption = (): Warehouse => {
  const { t: translate } = useTranslation();

  return { name: translate("allWarehouses"), id: -1 };
};

export const getEmptyWarehouseOption = (): Warehouse => {
  const { t: translate } = useTranslation();

  return { name: translate("noWarehouses"), id: -2 };
};
